// NOMBASE - App Context (Composed)
// Combines all domain contexts into a single provider tree.
// useApp() merges all contexts for backward compatibility.
// (Cart + drawer UI contexts were removed with the marketplace/RFQ system —
// draft POs on /buy are the staging surface now.)
import React from 'react';
import { AuthProvider, useAuth } from './AuthContext';
import { SavedSuppliersProvider, useSavedSuppliers } from './SavedSuppliersContext';
import { FavoritesProvider, useFavorites } from './FavoritesContext';
import { CompareProvider, useCompare } from './CompareContext';

// Backward-compatible hook — merges all contexts
export const useApp = () => {
  const auth = useAuth();
  const saved = useSavedSuppliers();
  const favs = useFavorites();
  const compare = useCompare();
  return { ...auth, ...saved, ...favs, ...compare };
};

// Composed provider — wraps children in all domain providers
export const AppProvider = ({ children }) => (
  <AuthProvider>
    <SavedSuppliersProvider>
      <FavoritesProvider>
        <CompareProvider>
          {children}
        </CompareProvider>
      </FavoritesProvider>
    </SavedSuppliersProvider>
  </AuthProvider>
);

// Re-export domain hooks for targeted usage
export { useAuth } from './AuthContext';
export { useSavedSuppliers } from './SavedSuppliersContext';
export { useFavorites } from './FavoritesContext';
export { useCompare } from './CompareContext';
